import { combineEpics, Epic, ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import { notify } from '../../../services/notifier.service';
import { loopBackApi } from '../../models/LoopBack/Api/LoopBackApi';
import { delivererClient } from '../../services/deliverer/DelivererClient';
import * as types from './types';

const ActualRoutesEpic: Epic<any, any> = (action$, store) =>
  action$.pipe(
    ofType(types.ACTUAL_ROUTES_GET_REQUEST),
    mergeMap((action) =>
      loopBackApi()
        .get('routes/by-user')
        .then((res) => ({
          type: types.ACTUAL_ROUTES_GET_RECEIVED,
          payload: res.data
        }))
        .catch((err) => ({ type: types.ACTUAL_ROUTES_GET_ERROR }))
    )
  );

const ActualDepotRoutesEpic: Epic<any, any> = (action$, store) =>
  action$.pipe(
    ofType(types.ACTUAL_DEPOT_ROUTES_GET_REQUEST),
    mergeMap((action) =>
      loopBackApi()
        .get('routes/by-user-depot')
        .then((res) => ({
          type: types.ACTUAL_DEPOT_ROUTES_GET_RECEIVED,
          payload: res.data
        }))
        .catch((err) => ({ type: types.ACTUAL_DEPOT_ROUTES_ERROR }))
    )
  );

const RoutesEpic: Epic<any, any> = (action$, store) =>
  action$.pipe(
    ofType(types.RECENT_ROUTES_GET_REQUEST),
    mergeMap((action) =>
      loopBackApi()
        .get('routes/by-user', action.payload.filter)
        .then((res) => ({
          type: types.RECENT_ROUTES_GET_RECEIVED,
          payload: res.data
        }))
        .catch((err) => ({ type: types.RECENT_ROUTES_GET_ERROR }))
    )
  );

const RouteTemplatesEpic: Epic<any, any> = (action$, store) =>
  action$.pipe(
    ofType(types.ROUTE_TEMPLATES_GET_REQUEST),
    mergeMap((action) =>
      loopBackApi()
        .get('route-templates/by-user', action.payload.filter)
        .then((res) => ({
          type: types.ROUTE_TEMPLATES_GET_RECEIVED,
          payload: res.data
        }))
        .catch((err) => ({ type: types.ROUTE_TEMPLATES_GET_ERROR, payload: err }))
    )
  );

const RouteDeclarationFormInformationEpic: Epic<any, any> = (action$, store) =>
  action$.pipe(
    ofType(types.ROUTE_DECLARATION_FORM_INFORMATION_GET_REQUEST),
    mergeMap(() =>
      delivererClient
        .getRouteDeclarationFormInformation()
        .then((res) => ({
          type: types.ROUTE_DECLARATION_FORM_INFORMATION_GET_RECEIVED,
          payload: res
        }))
        .catch((err) => {
          notify({
            title: 'Helaas',
            html:
              'Op dit moment kan het kilometerdeclaratie formulier niet worden opgehaald. Probeer het later nogmaals',
            type: 'error'
          });
          return { type: types.ROUTE_DECLARATION_FORM_INFORMATION_GET_ERROR, payload: err };
        })
    )
  );

export const routeEpics = combineEpics(
  ActualRoutesEpic,
  RouteTemplatesEpic,
  RoutesEpic,
  ActualDepotRoutesEpic,
  RouteDeclarationFormInformationEpic
);
